export default "__VITE_ASSET__DrgOpV6K__"